import { talkProject } from '../../agents-api.ts';
import type { ProjectInfo } from '../../agents-api.ts';
import { h } from '../../ui.ts';

/** Which project the next talk is about: chips, remembered on this device and sent with POST /talk. */
export function projectSwitcher(projects: ProjectInfo[], changed: () => void): HTMLElement {
  const current = () => talkProject();
  const chip = (slug: string | null, label: string) => {
    const on = (current() ?? null) === slug;
    return h(
      'button',
      {
        type: 'button',
        class: `p-switch-chip ${on ? 'on' : ''}`,
        'aria-pressed': on ? 'true' : 'false',
        onclick: () => {
          talkProject(slug);
          wrap.replaceChildren(...chips());
          changed();
        },
      },
      label,
    );
  };
  const chips = () => [chip(null, 'Anything'), ...projects.map((p) => chip(p.slug, p.name))];
  const wrap = h('div', { class: 'p-switch', role: 'group', 'aria-label': 'Talk about' }, ...chips());
  return h('div', { class: 'p-switch-wrap' }, h('span', { class: 'p-label' }, 'Talk about'), wrap);
}

/** The talk button's words: "Talk about Convasi", or back to an open talk. */
export function talkButtonLabel(projects: ProjectInfo[], open: boolean): string {
  if (open) return 'Back to the talk';
  const p = projects.find((x) => x.slug === talkProject());
  return p ? `Talk about ${p.name}` : 'Start talking';
}

/** The remembered project, when it still exists. */
export function chosenProject(projects?: ProjectInfo[]): string | undefined {
  const slug = talkProject();
  if (!slug) return undefined;
  return !projects || projects.some((p) => p.slug === slug) ? slug : undefined;
}
